﻿export function saveAsFile(fileName: String, base64data: String) {
	var link = document.createElement('a');
	link.download = fileName.toString();
	link.href = "data:application/octet-stream;base64," + base64data;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}